import { withChartLayout } from 'components/common';
import PostpartumInterventions from 'components/features/chart/system-nursing-interventions/postpartum-interventions/PostpartumInterventions';

const PostpartumInterventionsPage = withChartLayout('Postpartum Interventions')(PostpartumInterventions);
export default PostpartumInterventionsPage;
